<template>
    <div class="container">
        <h2 class="unselectable">Kiitos, kun kävit Trigenda-keskustelun!</h2>
        <button id="saveButton" @click="savePDF">
            <div id="buttonContent">
                <span id="buttonText">Tallenna keskustelu</span>
                <div id="buttonImage"></div>
            </div>
        </button>
    </div>
</template>

<script>
import { jsPDF } from "jspdf";
export default {
    name: 'SavePDF',
    setup() {

        const savePDF = () => {
            const cardArray = JSON.parse(localStorage.getItem('cardArray'));
            // Const feedbackCards = JSON.parse(localStorage.getItem('feedbackCards'));
            const deckInfo = JSON.parse(localStorage.getItem('deckInfo'));
            const summaryAnswers = JSON.parse(localStorage.getItem('summaryAnswers'));
            const feedbackFetched = JSON.parse(localStorage.getItem('feedbackCards'));
            const feedbacks = [];

            feedbackFetched.map(item => {
                if(item.answer)
                    feedbacks.push({answer: item.answer, card: item.description})
            });

            const chosenPhaseTwoCards = [];

            const goalCardP2 = cardArray.find(card => card.phase2selection === 'Tavoite');
            const challengeCardP2 = cardArray.find(card => card.phase2selection === 'Haaste');
            const assetOneCardP2 = cardArray.find(card => card.phase2selection === 'Voimavara1');
            const assetTwoCardP2 = cardArray.find(card => card.phase2selection === 'Voimavara2');

            chosenPhaseTwoCards.push(goalCardP2, challengeCardP2, assetOneCardP2, assetTwoCardP2);

            const selectedDeckType = deckInfo.type;
            const selectedDeckName = deckInfo.name;

            const summaryAnswer1 = summaryAnswers[0].comment;
            const summaryAnswer2 = summaryAnswers[1].comment;
            const summaryAnswer3 = summaryAnswers[2].comment;
            const summaryAnswer4 = summaryAnswers[3].comment;

            let feedbackAnswer1 = {answer:'-', card:''};
            let feedbackAnswer2 = {answer:'-', card:''};
            let feedbackAnswer3 = {answer:'-', card:''};

            if(feedbacks.length > 0)
                feedbackAnswer1 = feedbacks[0];

            if(feedbacks.length > 1)
                feedbackAnswer2 = feedbacks[1];

            // It's possible to give feedback only with 2 cards
            if(feedbacks.length > 2)
                feedbackAnswer3 = feedbacks[2];

            let today = new Date();
            const dd = String(today.getDate()).padStart(2, '0');
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const yyyy = today.getFullYear();

            today = dd + '.' + mm + '.' + yyyy;

            // Default export is a4 paper, portrait, using millimeters for units
            const doc = new jsPDF({
                orientation: 'p',
                unit: 'px',
                format: 'a4',
                putOnlyUsedFonts: true
            });

            const docWidth = doc.internal.pageSize.getWidth();
            const docHeight = doc.internal.pageSize.getHeight();

            doc.line(20, 80, docWidth - 20, 80);
            doc.line(20, 105, docWidth - 20, 105);
            doc.line(20, 130, docWidth / 2 - 5, 130);
            doc.line(docWidth / 2 + 5, 130, docWidth - 20, 130);
            doc.line(20, 155, docWidth / 2 - 5, 155);
            doc.line(docWidth / 2 + 5, 155, docWidth - 20, 155);
            doc.line(20, 180, docWidth - 20, 180);

            doc.rect(5, 5, docWidth - 10, docHeight - 10);

            doc.rect(20, 200, docWidth - 40, 90);
            doc.rect(20, 200, docWidth - 40, 12);

            doc.rect(20, 305, docWidth - 40, 90);
            doc.rect(20, 305, docWidth - 40, 12);

            doc.rect(20, 410, docWidth - 40, 90);
            doc.rect(20, 410, docWidth - 40, 12);

            doc.rect(20, 515, docWidth - 40, 90);
            doc.rect(20, 515, docWidth - 40, 12);

            // Add Trigenda Header

            doc.setFontSize(17);
            doc.text('Trigenda® keskustelun yhteenveto', docWidth / 2 - 90, 35)

            doc.setFontSize(15);
            doc.text(`Päiväys: ${today}`, 20, 75);
            doc.text(`Valittu sarja: ${selectedDeckName} / ${selectedDeckType}`, 20, 100);
            doc.text(`Tavoite: ${goalCardP2.description}`, 20, 125);
            doc.text(`Haaste: ${challengeCardP2.description}`, 230, 125);
            doc.text(`Voimavara 1: ${assetOneCardP2.description}`, 20, 150);
            doc.text(`Voimavara 2: ${assetTwoCardP2.description}`, 230, 150);
            doc.text(`Aihe valikoitui seuraavasta pinosta: ${goalCardP2.phase1selection}`, 20, 175);
            doc.setFontSize(12.5);
            doc.text(`Keskustelun pääsisällöt, mistä asioista keskusteltiin:`, 25, 210);
            doc.text(`Keskustelussa nousseet tavoitteet ja keinot niiden saavuttamiseksi:`, 25, 315);
            doc.text(`Keskustelun oivallukset:`, 25, 420);
            doc.text(`Aiheet, joista voi vielä jatkaa:`, 25, 525);
            doc.setFontSize(10);
            doc.text(summaryAnswer1, 25, 222.5, {
                maxWidth: 395,
                align: 'left'
            });
            doc.text(summaryAnswer2, 25, 327.5, {
                maxWidth: 395,
                align: 'left'
            });
            doc.text(summaryAnswer3, 25, 432.5, {
                maxWidth: 395,
                align: 'left'
            });
            doc.text(summaryAnswer4, 25, 537.5, {
                maxWidth: 395,
                align: 'left'
            });

            // Feedback, Page 2
            doc.addPage();

            doc.rect(5, 5, docWidth - 10, docHeight - 10);

            doc.rect(20, 50, docWidth - 40, 90);
            doc.rect(20, 50, docWidth - 40, 12);

            doc.rect(20, 150, docWidth - 40, 90);
            doc.rect(20, 150, docWidth - 40, 12);

            doc.rect(20, 250, docWidth - 40, 90);
            doc.rect(20, 250, docWidth - 40, 12);

            doc.setFontSize(15);
            doc.text('Palaute Trigenda® keskustelusta', 20, 30);

            doc.setFontSize(12.5);
            doc.text(`Keskeiset ajatukset valitun käsitekortin "${feedbackAnswer1.card}" pohjalta:`, 25, 60);
            doc.text(`Keskeiset ajatukset valitun käsitekortin "${feedbackAnswer2.card}" pohjalta:`, 25, 160);

            if(feedbacks.length > 2)
                doc.text(`Keskeiset ajatukset valitun käsitekortin "${feedbackAnswer3.card}" pohjalta:`, 25, 260);
            else
                doc.text(`Keskustelija antoi palautteen kahden käsitekortin avulla`, 25, 260);

            doc.setFontSize(10);

            doc.text(feedbackAnswer1.answer, 25, 72, {
                maxWidth: 395,
                align: 'left'
            });

            doc.text(feedbackAnswer2.answer, 25, 172, {
                maxWidth: 395,
                align: 'left'
            });

            doc.text(feedbackAnswer3.answer, 25, 272, {
                maxWidth: 395,
                align: 'left'
            });

            /**
             *Function getBase64Image(src, callback) {
             *   const img = new Image();
             *   img.crossOrigin = 'Anonymous';
             *   img.addEventListener('load', function() {
             *       const canvas = document.createElement('canvas');
             *       const ctx = canvas.getContext('2d');
             *       let dataURL;
             *       canvas.height = img.naturalHeight;
             *       canvas.width = img.naturalWidth;
             *       ctx.drawImage(img, 0, 0);
             *       dataURL = canvas.toDataURL('png');
             *       callback(dataURL);
             *   }, false);
             *   img.src = src;
             *}
             *getBase64Image('http://localhost:8080/img/DigiLogo.ae6d527d.png', (response) => {
             *   // Logo size: 215 x 75 pixels
             *   doc.addImage(response, 'png', 163, 10);
             *   doc.save("Trigenda_yhteenveto.pdf");
             *})
             */
            doc.save("Trigenda_yhteenveto.pdf");
        }

        return { savePDF };
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#saveButton {
    padding: 5px 30px;
}

#buttonContent {
  display: flex;
  align-items: center;
}

#buttonText {
    margin: 0 10px 0 0;
}

#buttonImage {
    background: url("../assets/PdfLogo.png") no-repeat;
    background-size: 30px 30px;
    width: 30px;
    height: 30px;
}

.unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

</style>
